import React from 'react';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import './BaasInfoSection.scss';
import EllipseRight from '../../../../assets/smartxonnect/EllipseRight.webp';
import EllipseLeft from '../../../../assets/smartxonnect/EllipseLeft.webp';
import BottomLeft from '../../../../assets/smartxonnect/bottom-left.webp';

const svgCode = `
<svg width="100%" height="100%" viewBox="0 0 1440 149" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice">
  <path d="M-247 79.5064C-163.367 8.91395 -56.1086 83.9382 121.08 102.932C128.404 103.881 135.964 104.198 143.524 103.881C276.061 98.1833 389.056 1.00012 536.647 1" stroke="#0D0D0D" stroke-width="0.542863" stroke-miterlimit="10"/>
  <path d="M1441 79.5064C1344.1 8.91395 1219.82 83.9382 1014.51 102.932C1006.03 103.881 997.265 104.198 988.506 103.881C834.937 98.1833 704.012 1.00012 533 1" stroke="#0D0D0D" stroke-width="0.542863" stroke-miterlimit="10"/>
  <path d="M-184.41 132.954C12.6232 139.657 23.2736 -1.91186 130.37 1.04571C132.342 1.04571 134.314 1.04571 136.484 1.04571C248.511 -1.91186 291.31 169.036 469.804 145.573" stroke="#0D0D0D" stroke-width="0.5" stroke-miterlimit="10"/>
  <path d="M1059.8 132.954C862.771 139.657 852.121 -1.91186 745.025 1.04571C743.052 1.04571 741.08 1.04571 738.911 1.04571C626.884 -1.91186 584.085 169.036 405.591 145.573" stroke="#0D0D0D" stroke-width="0.5" stroke-miterlimit="10"/>
  <path d="M1033.59 132.954C1230.62 139.657 1241.27 -1.91186 1348.37 1.04571C1350.34 1.04571 1352.31 1.04571 1354.48 1.04571C1466.51 -1.91186 1509.31 169.036 1687.8 145.573" stroke="#0D0D0D" stroke-width="0.5" stroke-miterlimit="10"/>
  <path d="M-184.41 102.218C-46.546 114.048 -11.6362 77.5713 47.3358 51.7418C90.332 32.8134 138.456 30.4473 183.425 43.855C285.393 74.4166 343.379 128.836 469.804 75.994" stroke="#0D0D0D" stroke-width="2" stroke-miterlimit="10"/>
  <path d="M924.805 102.218C786.941 114.048 752.031 77.5713 693.059 51.7418C650.062 32.8134 601.938 30.4473 556.97 43.855C455.001 74.4166 397.016 128.836 270.591 75.994" stroke="#0D0D0D" stroke-width="2" stroke-miterlimit="10"/>
  <path d="M831.59 102.218C969.454 114.048 1004.36 77.5713 1063.34 51.7418C1106.33 32.8134 1154.46 30.4473 1199.42 43.855C1301.39 74.4166 1359.38 128.836 1485.8 75.994" stroke="#0D0D0D" stroke-width="2" stroke-miterlimit="10"/>
</svg>
`;

const infoStyle = `<svg class="info-style" xmlns="http://www.w3.org/2000/svg" width="139" height="111" viewBox="0 0 139 111" fill="none">
  <path d="M60.7332 48.5212V17.1365V0H0.00298967C0.149152 1.54036 0.353779 15.3266 0.00298967 58.1485C-0.347799 100.97 30.2585 110.906 45.6056 110.521H138.345V58.1485H69.9414C62.0486 58.1485 60.5139 51.7303 60.7332 48.5212Z" fill="#FFFAD4"></path>
</svg>`;

const BaasInfoSection = (props) => {
  return (
    <div id="info-section" className="info-section" data-aos="fade-up">
      <div className="info-title-subtitle">
        <h1 className="title roboto-bold">
          <Text field={props.fields?.Title} />
        </h1>
        <p className="subtitle">
          <Text field={props.fields?.SubTitle} />
        </p>
      </div>
      {/* <div className="info-style" dangerouslySetInnerHTML={{ __html: infoStyle }} /> */}
      <div className="info-container">
        <div className="info-style">
          <img src={BottomLeft} alt="Info Style Bottom Left" className="bottom-left" />
        </div>
        <div className="content-wrapper">
          <div className="rounded">
            <h2 className="highlight-title">
              <Text field={props.fields?.HighlightTitle} />
            </h2>
            <p className="highlight-description">
              <Text field={props.fields?.HighlightDescription} />
            </p>
          </div>
        </div>
        {/* <div className="info-styleright" dangerouslySetInnerHTML={{ __html: infoStyle }} /> */}
      </div>
      <div className="wave-container d-none" dangerouslySetInnerHTML={{ __html: svgCode }} />
      <img src={EllipseLeft} alt="Left Gradient" className="ellipse-left" />
      <img src={EllipseRight} alt="Right Gradient" className="ellipse-right" />
    </div>
  );
};

export default React.memo(BaasInfoSection);
